<template>
  <div class="overlay__body">
    <span class="overlay__text">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.overlay {
  &__body {
    position: absolute;
    background-color: $white;
    opacity: 0.9;
  }
  &__text {
    font-family: $font-family-base;
    font-size: 12px;
    letter-spacing: $letter-spacing-xs;
    line-height: 18px;
    text-align: center;
    color: $black;
  }
}
</style>
